import React from 'react';
import { PromoBar } from '../components/PromoBar';
import { HeroSection } from '../components/HeroSection';
import { PainPoints } from '../components/PainPoints';
import { Benefits } from '../components/Benefits';
import { ProductDetails } from '../components/ProductDetails';
import { BonusSection } from '../components/BonusSection';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0a0e17] text-[#f5f0e8] overflow-x-hidden selection:bg-[#d4a853] selection:text-[#0a0e17]" data-id="element-153">
      <PromoBar data-id="element-154" />
      <HeroSection data-id="element-155" />
      <PainPoints data-id="element-156" />
      <Benefits data-id="element-157" />
      <ProductDetails data-id="element-158" />
      <BonusSection data-id="element-159" />
      <Testimonials data-id="element-160" />
      <FinalCTA data-id="element-161" />
    </main>;
}